import styled from 'styled-components';

export default {
  SortWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 16px;
  `,

  AnnouncementCountWrapper: styled.div`
    display: flex;
    align-items: center;
  `,

  AnnouncementCount: styled.span`
    font-weight: 600;
  `,

  SortContainer: styled.div`
    display: flex;
    align-items: center;
    position: relative;
  `,

  Button: styled.button`
    background: transparent;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #151035;
  `,

  TrianglesWrapper: styled.div`
    display: flex;
    flex-direction: column;
    margin-right: 8px;
  `,
};
